import Joi from 'joi';
import { visualPropEditorDefinitionSchema } from '../../common/joi-validation-schemas';
export const validateSDKVisualPropEditorDefinition = (sdkChartVisualPropEditorDefinition, logger) => {
    try {
        Joi.assert(sdkChartVisualPropEditorDefinition, visualPropEditorDefinitionSchema);
    }
    catch (err) {
        logger?.error('visualPropEditorDefinition is invalid', err);
        return false;
    }
    return true;
};
//# sourceMappingURL=util.js.map